import type { Node } from "@tiptap/pm/model";
import { NodeViewWrapper } from "@tiptap/react";
import { ZoomImage } from "../../MarkdownRenderer/ZoomImage";

export const ImageNodeViewWrapper = ({ node }: { node: Node }) => {
	return (
		<NodeViewWrapper>
			<ZoomImage allImages={[{ url: node.attrs.src }]} url={node.attrs.src} />
		</NodeViewWrapper>
	);
};
